export default {"src":"/_next/static/media/voucher.35ee9c94.svg","height":16,"width":16};